import React from "react";
import { FaArrowRight, FaLocationDot } from "react-icons/fa6";
import { BTN_SIZE, Container, H2_SIZE } from "../home/ui";
import { contactInfo } from "./contactInfo";

const q = encodeURIComponent(contactInfo.mapQuery);
const mapSrc = `https://www.google.com/maps?q=${q}&z=15&output=embed`;
const directionsHref = `https://www.google.com/maps/dir/?api=1&destination=${q}`;

const ContactLocation = () => (
  <section className="bg-[#F7F9FE] pb-[48px] lg:pb-[72px]">
    <Container className="max-w-[1320px]">
      <div className="grid gap-[24px] rounded-[20px] bg-white p-[20px] shadow-[0_18px_50px_-24px_rgba(40,60,140,0.3)] sm:p-[24px] lg:grid-cols-[minmax(0,0.75fr)_minmax(0,1.6fr)] lg:items-center lg:gap-[32px]">
        <div className="lg:pl-[8px]">
          <span className="inline-block rounded-full bg-[#E3EDFF] px-[14px] py-[5px] text-[12px] font-semibold uppercase tracking-[0.04em] text-[#1E4DFF]">
            Our Location
          </span>
          <h2 className={`mt-[12px] font-extrabold tracking-tight text-[#0B1A4A] ${H2_SIZE}`}>Visit Our Office</h2>
          <p className="mt-[10px] max-w-[320px] text-[15px] leading-[1.6] text-slate-600">
            We&apos;d love to meet you in person. Find us at the location below.
          </p>

          <div className="mt-[20px] flex items-start gap-[14px] rounded-[14px] bg-[#EEF3FE] px-[18px] py-[16px]">
            <FaLocationDot className="mt-[3px] shrink-0 text-[24px] text-[#1E3A8A]" />
            <p className="text-[15px] leading-[1.5] text-[#0B1A4A]">
              {contactInfo.addressLine1}
              <br />
              {contactInfo.addressLine2}
            </p>
          </div>

          <a
            href={directionsHref}
            target="_blank"
            rel="noopener noreferrer"
            className={`group mt-[20px] inline-flex items-center rounded-full border-[1.5px] border-solid border-[#1E6BFF] bg-white font-medium text-[#1E4DFF] transition hover:bg-[#EEF3FF] ${BTN_SIZE}`}
          >
            Get Directions
            <FaArrowRight className="text-[13px] transition group-hover:translate-x-1" />
          </a>
        </div>

        <div className="h-[280px] overflow-hidden rounded-[16px] sm:h-[340px] lg:h-[clamp(320px,24vw,440px)]">
          <iframe
            title="DataMetricks office location map"
            src={mapSrc}
            className="h-full w-full border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>
      </div>
    </Container>
  </section>
);

export default ContactLocation;
